import { useContext } from "react";
import { SharedApiContext, type SharedApiContextValue } from "./shared-api-context";

export const useSharedApi = (): SharedApiContextValue => {
  const context = useContext(SharedApiContext);
  if (!context) {
    throw new Error("useSharedApi must be used within a SharedApiProvider");
  }
  return context;
};
